import axios from 'axios';
import config from '../config/config';

const headers = () => {
  return {
    headers: {
      'Authorization': 'Bearer ' + localStorage.getItem('id_token'),
    }
  };
};

const urlAPI = config.URL_API_BASE;
const servico = '/motorista-complemento/';

export const cadastrarMotoristaComplemento = ({
  cd_motorista,
  cd_veiculo_fabricante,
  veiculo_modelo,
  veiculo_ano,
  veiculo_placa,
  encosto_cabeca,
  posse_veiculo,
  idc_veiculo_proprio,
  idc_motorista_kovi,
}) => {
  return axios.post(
    urlAPI + servico,
    {
      cd_motorista,
      cd_veiculo_fabricante,
      veiculo_modelo,
      veiculo_ano,
      veiculo_placa,
      encosto_cabeca,
      posse_veiculo,
      idc_veiculo_proprio,
      idc_motorista_kovi,
    },
    headers()
  );
};
